"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genericFilter = exports.genericSort = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_core_1 = require("@patternfly/react-core");
var magnifying_glass_svg_1 = __importDefault(require("@fortawesome/fontawesome-pro/svgs/regular/magnifying-glass.svg"));
var ZIBasicTable_1 = __importDefault(require("./ZIBasicTable"));
function genericSort(rows, setSortBy, setRows) {
    return function (_event, index, direction) {
        var sortedRows = rows.sort(function (a, b) {
            if (a[index] < b[index]) {
                return -1;
            }
            else if (a[index] > b[index]) {
                return 1;
            }
            return 0;
        });
        setSortBy({
            index: index,
            direction: direction,
        });
        setRows(direction === 'asc' ? sortedRows : sortedRows.reverse());
    };
}
exports.genericSort = genericSort;
function genericFilter(repo, setRows, setFilter) {
    return function (value) {
        var filtered = [];
        repo.map(function (row) {
            if (Array.isArray(row)) {
                for (var i = 0; i < row.length; i++) {
                    var element = row[i];
                    var val = void 0;
                    if (typeof element === 'object') {
                        var title = element.title;
                        val = String(title);
                    }
                    else {
                        val = element;
                    }
                    if (String(val).match(RegExp(value, 'gi'))) {
                        filtered.push(row);
                        break;
                    }
                }
            }
            else {
                throw new Error('generic filter does not support objects');
            }
        });
        setRows(filtered);
        setFilter(value);
    };
}
exports.genericFilter = genericFilter;
function ZIFilterPaginateTable(props) {
    var _a = react_1.default.useState(1), page = _a[0], setPage = _a[1];
    var _b = react_1.default.useState(10), perPage = _b[0], setPerPage = _b[1];
    var onSetPage = function (_event, newPage) {
        setPage(newPage);
    };
    var onPerPageSelect = function (_event, newPerPage, newPage) {
        setPerPage(newPerPage);
        setPage(newPage);
    };
    var content = props.rows.slice((page - 1) * perPage, (page - 1) * perPage + perPage);
    return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsxs)(react_core_1.Grid, __assign({ hasGutter: true }, { children: [(0, jsx_runtime_1.jsx)(react_core_1.GridItem, __assign({ span: 3 }, { children: (0, jsx_runtime_1.jsx)(react_core_1.TextInput, { value: props.filter.value, type: "text", customIconUrl: magnifying_glass_svg_1.default, placeholder: "Filter", onChange: props.filter.onChange, "aria-label": "Filter table" }) })), (0, jsx_runtime_1.jsx)(react_core_1.GridItem, __assign({ span: 9, style: { justifySelf: 'end' } }, { children: props.additionalActions })), (0, jsx_runtime_1.jsx)(react_core_1.GridItem, __assign({ span: 12 }, { children: props.loaded ? ((0, jsx_runtime_1.jsx)(ZIBasicTable_1.default, { ariaLabel: props.ariaLabel, columns: props.columns, rows: content, sortBy: props.sortBy, actions: props.actions, onSort: props.onSort })) : ((0, jsx_runtime_1.jsx)(react_core_1.Flex, __assign({ justifyContent: { default: 'justifyContentCenter' } }, { children: (0, jsx_runtime_1.jsx)(react_core_1.FlexItem, { children: (0, jsx_runtime_1.jsx)(react_core_1.Spinner, { isSVG: true, diameter: '40px' }) }) }))) }))] })), (0, jsx_runtime_1.jsx)(react_core_1.Pagination, { perPageComponent: "button", itemCount: props.rows.length, perPage: perPage, page: page, onSetPage: onSetPage, widgetId: "top-example", variant: 'bottom', onPerPageSelect: onPerPageSelect })] }));
}
exports.default = ZIFilterPaginateTable;
